export const selectStation = (state) => state.user.station
